const LOCALSTORAGE_KEYS = {
  CART: 'cart'
} as const;

export default LOCALSTORAGE_KEYS;
